import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const OAuthCallbackPage: React.FC = () => {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');
    const userEmail = searchParams.get('user_email');
    const userName = searchParams.get('user_name');
    const userRole = searchParams.get('user_role');
    
    if (accessToken && refreshToken) {
      // Store tokens and user info in localStorage
      localStorage.setItem('user_email', userEmail || '');
      localStorage.setItem('user_name', userName || '');
      localStorage.setItem('user_role', userRole || '');
      
      // Use loginWithToken to set auth context
      loginWithToken(accessToken, refreshToken);
      
      // Redirect to home
      navigate('/');
    } else {
      navigate('/login');
    }
  }, [searchParams, loginWithToken, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px',
      color: '#666'
    }}>
      Processing login...
    </div>
  );
};
